module.exports = __webpack_public_path__ + "img/uefa-champions-league-103__dark.16100ff9.png";